import { render, staticRenderFns } from "./ClaimApprovalDetails.vue?vue&type=template&id=52c52f6a&scoped=true"
import script from "./ClaimApprovalDetails.vue?vue&type=script&lang=js"
export * from "./ClaimApprovalDetails.vue?vue&type=script&lang=js"
import style0 from "./ClaimApprovalDetails.vue?vue&type=style&index=0&id=52c52f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c52f6a",
  null
  
)

export default component.exports